import React from "react";
import {Button} from "@material-ui/core";
import loader from "api/loader";
import {PORTAL_URLS, getTiposOperacion, portalConfig} from "portal";

export default function PortalNoAutorizado({transportista}){
	const tiposPermitidos = getTiposOperacion(transportista);
	const portalPermitido = tiposPermitidos[0];

	const cerrarSesion = async () => {
		window.localStorage.removeItem(process.env.REACT_APP_KEY);
		await loader.init();
		window.location.replace("/login");
	};

	return <div className="min-h-screen flex items-center justify-center p-5">
		<div className="bg-white rounded-2xl p-10 text-center max-w-lg shadow-md">
			<div className="text-blue text-2xl font-black">Portal no autorizado</div>
			<div className="text-gray mt-3">
				Tu cuenta no tiene acceso al portal de {portalConfig.label}.
			</div>
			<div className="flex gap-3 justify-center mt-6">
				{portalPermitido && <Button
					variant="contained"
					color="primary"
					onClick={() => window.location.assign(PORTAL_URLS[portalPermitido])}
				>
					Ir a mi portal
				</Button>}
				<Button onClick={cerrarSesion}>Cerrar sesión</Button>
			</div>
		</div>
	</div>;
}
